export class GMXFlyout extends HTMLElement {
    private triggerEl: HTMLElement | null = null;
    private closeOnSelection = false;
    private flyoutMode: 'dropdown' | 'content' | 'menu' = 'dropdown';

    connectedCallback(): void {
        this.closeOnSelection = this.getAttribute('close-on-selection') === 'true';
        this.flyoutMode = this.getAttribute('type') as 'dropdown' | 'content' | 'menu' || 'dropdown';
        this.classList.add(`gmx-flyout-${this.flyoutMode}`);
        this.triggerEl?.classList.toggle('gmx-flyout-trigger', true);

        let triggerEl: HTMLElement | null = null;
        const anchorAttr = this.getAttribute('anchor');
        const idAttr = this.getAttribute('id');
        if (anchorAttr) {
            triggerEl = document.querySelector<HTMLElement>(`#${anchorAttr}`);
        } else if (idAttr) {
            triggerEl = document.querySelector<HTMLElement>(`:is([data-target="${idAttr}"], [popovertarget="${idAttr}"])`);
        }
        this.triggerEl = triggerEl;

        const uniqueID = this.triggerEl?.id || window.crypto.randomUUID();
        this.triggerEl?.style.setProperty('anchor-name', `--flyout-anchor-${uniqueID}`);
        this.style.setProperty('position-anchor', `--flyout-anchor-${uniqueID}`);

        // add attribute popover if it doesn't exist
        if (!this.hasAttribute('popover')) {
            this.setAttribute('popover', '');
        }

        // add attribute popovertarget if it doesn't exist and data-target does
        if (!this.triggerEl?.hasAttribute('popovertarget') && this.triggerEl?.hasAttribute('data-target')) {
            this.triggerEl.setAttribute('popovertarget', this.triggerEl.getAttribute('data-target') as string);
        }

        // add attribute popovertarget if it doesn't exist and data-target does
        if (this.hasAttribute('align') || this.hasAttribute('popover-align')) {
            this.setAttribute('popoveralign', this.getAttribute('align') || this.getAttribute('popover-align') as string);
        }

        if (this.triggerEl?.getBoundingClientRect()) {
            // Fix for popover positioning in Safari and Firefox (remove when anchor is supported)
            this.style.setProperty('--trigger-height', `${this.triggerEl.getBoundingClientRect().height}px`);
            this.style.setProperty('--trigger-width', `${this.triggerEl.getBoundingClientRect().width}px`);

            // move the element to directly follow the trigger (remove when anchor is supported)
            if (this.triggerEl.nextSibling != this) {
                this.triggerEl.after(this);
            }
        }

        this.addEventListener('click', this._handleClick);
    }

    disconnectedCallback(): void {
        this.triggerEl = null;
        this.removeEventListener('click', this._handleClick);
    }

    _handleClick(event: MouseEvent): void {
        if (event.target !== this) {
            const selectedValue = (event.target as HTMLButtonElement).value || (event.target as HTMLElement).innerText;
            this.setAttribute('value', selectedValue);
            this.dispatchEvent(new Event('change', { bubbles: true }))

            if (
                this.closeOnSelection ||
                this.flyoutMode === 'content' ||
                (event.target as HTMLElement).getAttribute?.('popovertargetaction') === 'close'
            ) {
                this.hidePopover();
            }
        }
    }
}

if (!customElements.get('gmx-flyout')) {
	customElements.define('gmx-flyout', GMXFlyout);
}
